import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import DOMPurify from "dompurify";
import knowledgeService from "../services/knowledgeService";

const PublicHeader = () => (
  <header className="border-b border-gray-200 bg-white">
    <div className="mx-auto flex max-w-4xl items-center gap-2 px-4 py-4">
      <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 font-bold text-white">B</span>
      <span className="text-lg font-extrabold text-gray-900">BenDesk</span>
      <span className="ml-2 text-sm text-gray-500">Central de Ajuda</span>
    </div>
  </header>
);

const KBPublicaArtigo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    knowledgeService
      .getPublic(id)
      .then((d) => setArticle(d))
      .catch(() => setArticle(null))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <main className="mx-auto max-w-4xl px-4 py-8">
        <button type="button" onClick={() => navigate("/kb")} className="mb-4 inline-flex items-center gap-1 text-sm text-blue-600 hover:underline">
          <ArrowLeft size={16} /> Voltar
        </button>
        {loading ? (
          <div className="py-16 text-center text-gray-500">Carregando...</div>
        ) : !article ? (
          <div className="py-16 text-center text-gray-500">Artigo não encontrado ou não está público.</div>
        ) : (
          <div className="rounded-xl border border-gray-200 bg-white p-6">
            {article.category && (
              <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">{article.category}</span>
            )}
            <h1 className="mt-2 text-2xl font-bold text-gray-900">{article.title}</h1>
            <div
              className="mt-4 text-sm leading-relaxed text-gray-800 break-words [&_a]:text-blue-600 [&_img]:max-w-full [&_h2]:text-lg [&_h2]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.body || "") }}
            />
          </div>
        )}
      </main>
    </div>
  );
};

export default KBPublicaArtigo;
